import React, { useRef, useEffect, useState } from 'react'
import IconCamera from './image/IconCamera.svg'
import Icon, { getIcon } from 'e-submission/components/Icon'
const video = document.querySelector('video')
import { state_action } from './ActionHelper'

const OCRCamera = ({ onNextPage, Image, typemodal, setCamaraStream }) => {
  const videoRef = useRef(null)
  const canvasRef = useRef(null)
  const [cameraFacingMode, handleCameraFacingMode] = useState('environment')
  const [downloadLink, setDownloadLink] = useState('')
  const [TxtMessage, setTxtMessage] = useState('')
  const [StatusModal, setStatusModal] = useState(false)
  const [CurrentVdo, setCurrentVdo] = useState(null)
  const [ViewSize, setViewSize] = useState({ width: 1920, height: 1080 })

  const ScreenFrameCamera = window.innerHeight * 0.7
  const ScreenFrameCamera_haft = ScreenFrameCamera / 2

  useEffect(() => {
    try {
      let screenW = window.innerWidth * 0.8
      // console.log('screenW', screenW)
      setViewSize({
        width: screenW,
        height: Math.round((screenW / 16) * 9),
      })
      const ElementVideo = document.getElementsByTagName('video')[0]

      if (ElementVideo) {
        setCurrentVdo(ElementVideo)
      }

      const constraints = {
        audio: false,
        video: {
          width: screenW,
          height: Math.round((screenW / 16) * 9),
        },
      }
      navigator.mediaDevices
        .getUserMedia(constraints)
        .then((stream) => {
          setCamaraStream(stream)
          videoRef.current.srcObject = stream
        })
        .catch((err) => {
          setTxtMessage(err)
          setStatusModal(true)
          console.error('Error accessing camera: ', err)
        })
    } catch (error) {
      setTxtMessage(error)
      setStatusModal(true)
      console.error('Error accessing camera: ', error)
    }
  }, [])

  const capturePhoto = () => {
    const video = videoRef.current
    const videoVideoWidth = 700
    const videoVideoHeight = 700
    const canvas = canvasRef.current.getContext('2d')
    canvasRef.current.width = videoVideoWidth
    canvasRef.current.height = videoVideoHeight

    // Draw the video frame to the canvas
    canvas.drawImage(video, 0, 0, canvasRef.current.width, canvasRef.current.height)

    // Calculate the crop rectangle
    const cropWidth = canvasRef.current.width * 0.9
    const cropHeight = canvasRef.current.height * 0.4
    // const cropX = 0
    // const cropY = 0
    const cropX = canvasRef.current.width * 0.05
    const cropY = canvasRef.current.height * 0.3
    const imageData = canvas.getImageData(cropX, cropY, cropWidth, cropHeight)
    const croppedCanvas = document.createElement('canvas')
    croppedCanvas.width = cropWidth
    croppedCanvas.height = cropHeight
    const croppedContext = croppedCanvas.getContext('2d')
    croppedContext.putImageData(imageData, 0, 0)
    const dataURL = croppedCanvas.toDataURL('image/jpeg')

    onNextPage(state_action.previewimage, dataURL.replace('data:image/jpeg;base64,', ''))
  }

  return (
    <div
      style={{
        backgroundColor: 'transparent',
        width: '100%',
        // height: '100%',
        // display: 'flex',
        // justifyContent: 'center',
        // alignItems: 'center',
      }}
    >
      <div
        id="cameraContainer"
        style={{
          position: 'relative',
          width: '100%',
          margin: '0px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <video
          ref={videoRef}
          id="OCRWebCam"
          style={{
            width: '100%',
            height: '100%',
          }}
          autoPlay
          playsInline
        ></video>
        <>
          <div
            style={{
              position: 'absolute',
              width: '700px',
              height: '35%',
              top: 0,
              left: 0,
              pointerEvents: 'none',
              backgroundColor: 'rgba(255,255,255,0.5)',
            }}
          />
          <div
            style={{
              position: 'absolute',
              width: '700px',
              height: '30%',
              top: '35%',
              left: 0,
              pointerEvents: 'none',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <div
              style={{
                width: '2%',
                height: '100%',
                backgroundColor: 'rgba(255,255,255,0.5)',
              }}
            />
            <div
              id="frame"
              style={{
                width: '96%',
                height: '100%',
                pointerEvents: 'none',
              }}
            />
            <div
              style={{
                width: '2%',
                height: '100%',
                backgroundColor: 'rgba(255,255,255,0.5)',
              }}
            />
          </div>
          <div
            style={{
              position: 'absolute',
              width: '700px',
              height: '35%',
              top: '65%',
              left: 0,
              pointerEvents: 'none',
              backgroundColor: 'rgba(255,255,255,0.5)',
            }}
          />
        </>
      </div>
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          position: 'absolute',
          bottom: '30%',
          left: 0,
        }}
      >
        <div
          style={{
            width: window.innerWidth * 0.8,
            display: 'flex',
            minHeight: 80,
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {CurrentVdo ? (
            <button
              id="captureButton"
              onClick={capturePhoto}
              style={{
                backgroundColor: '#FFF',
                borderRadius: '55px',
                width: '55px',
                height: '55px',
                color: 'white',
                border: 'none',
                cursor: 'pointer',
              }}
            >
              <img
                src={IconCamera}
                style={{
                  width: '35px',
                  height: '35px',
                }}
              />
            </button>
          ) : (
            <></>
          )}
        </div>
      </div>
      <canvas ref={canvasRef} id="canvasElement" style={{ width: window.innerWidth }}></canvas>
    </div>
  )
}

export default OCRCamera
